import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { useSession, useSessionContext } from "@supabase/auth-helpers-react";
import GrantCalenderAccess from "./components/GrantCalenderAccess";
import ScheduleMeetings from "./components/ScheduleMeetings";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function App() {
  const session = useSession();
  const { isLoading } = useSessionContext();

  if (isLoading) {
    return <></>;
  }

  return (
    <Router>
      <Helmet>
        <title>{session ? "Schedule Meetings | StudyBuddy" : "Grant Calendar Access | StudyBuddy"}</title>
        <meta
          name="description"
          content={
            session
              ? "Easily schedule and manage your classes with StudyBuddy's meeting scheduler."
              : "Grant calendar access to streamline your scheduling experience on StudyBuddy."
          }
        />
        <meta name="keywords" content="StudyBuddy, meetings, class scheduler, calendar access" />
        <meta property="og:title" content="StudyBuddy" />
        <meta
          property="og:description"
          content={
            session
              ? "Easily schedule and manage your classes with StudyBuddy's meeting scheduler."
              : "Grant calendar access to streamline your scheduling experience on StudyBuddy."
          }
        />
        <meta property="og:image" content="https://i.ibb.co/YB8KCst/Success-factors-pana.png" />
        <meta property="og:url" content="https://app.studybuddy.ing" />
      </Helmet>

      <div className="flex flex-col min-h-screen">
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={session ? <ScheduleMeetings /> : <GrantCalenderAccess />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </div>

        <footer className="w-full bg-gray-100 text-center py-4 mt-4 border-t">
          <p className="text-sm text-gray-600">
            &copy; {new Date().getFullYear()} StudyBuddy. All rights reserved.
            <span className="mx-2">|</span>
            <Link to="/privacy-policy" className="text-blue-600 hover:underline">
              Privacy Policy
            </Link>
          </p>
        </footer>
      </div>
    </Router>
  );
}

export default App;